import { AiTrackerEmailBlock } from '@/modules/issuer-dashboard/components/portfolios/AITrackerEmailBlock.tsx';
import { BaseModalProps, ModalContentWrapper } from 'ui';

export const IssuerPortfolioAITrackingModal = ({ open, onClose }: BaseModalProps) => {
  return (
    <ModalContentWrapper
      onClose={onClose}
      open={open}
      title={'AI Tracking'}
      classes={{ children: 'p-0' }}
    >
      <div className="p-3 sm:p-6 flex flex-col w-full gap-6">
        <AiTrackerEmailBlock />
      </div>
    </ModalContentWrapper>
  );
};
